/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestServiceInspectionReportAiDto } from '../../models/request-service-inspection-report-ai-dto';
import { ServiceInspectionReportAiResponseDto } from '../../models/service-inspection-report-ai-response-dto';

export interface DocumentAiControllerServiceInspectionReportAi$Params {
  ticketId: string;
  centerId: string;
  type: string;
      body: RequestServiceInspectionReportAiDto
}

export function documentAiControllerServiceInspectionReportAi(http: HttpClient, rootUrl: string, params: DocumentAiControllerServiceInspectionReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceInspectionReportAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerServiceInspectionReportAi.PATH, 'post');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceInspectionReportAiResponseDto>;
    })
  );
}

documentAiControllerServiceInspectionReportAi.PATH = '/api/document-ai/service-inspection-report-ai/{ticketId}';
